export interface ESignDocument {
  id: string
  name: string
  type: 'exchange_agreement' | 'identification_form' | 'closing_documents' | 'other'
  status: 'pending' | 'signed' | 'completed'
  signedAt?: Date
  signedBy?: string
  downloadUrl?: string
}

const E_SIGN_STORAGE_KEY = 'esign_documents'

export const eSigning = {
  getDocuments: (): ESignDocument[] => {
    try {
      const stored = localStorage.getItem(E_SIGN_STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  },

  addDocument: (document: Omit<ESignDocument, 'status'>): ESignDocument => {
    const docs = eSigning.getDocuments()
    const newDoc: ESignDocument = {
      ...document,
      status: 'pending'
    }
    docs.push(newDoc)
    localStorage.setItem(E_SIGN_STORAGE_KEY, JSON.stringify(docs))
    return newDoc
  },

  signDocument: async (documentId: string, signedBy: string): Promise<ESignDocument> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const docs = eSigning.getDocuments()
        const doc = docs.find(d => d.id === documentId)
        if (doc) {
          doc.status = 'signed'
          doc.signedAt = new Date()
          doc.signedBy = signedBy
          localStorage.setItem(E_SIGN_STORAGE_KEY, JSON.stringify(docs))
          resolve(doc)
        } else {
          throw new Error('Document not found')
        }
      }, 1500)
    })
  },

  completeDocument: (documentId: string): ESignDocument | null => {
    const docs = eSigning.getDocuments()
    const doc = docs.find(d => d.id === documentId)
    if (doc) {
      doc.status = 'completed'
      localStorage.setItem(E_SIGN_STORAGE_KEY, JSON.stringify(docs))
      return doc
    }
    return null
  },

  clearDocuments: (): void => {
    localStorage.removeItem(E_SIGN_STORAGE_KEY)
  }
}

